import React, { FC, ReactElement, useRef, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { StyleSheetManager } from 'styled-components'
import MainComponent from 'components/MainComponent'
import DevTools from 'DevTools'
import tenants from 'Constants/tenants'
import { MicroFrontendProps, TenantKey } from 'Types/MicroFrontendProps'

const App: FC<MicroFrontendProps> = (microFrontendProps): ReactElement => {
  const [ref, setRef] = useState<HTMLDivElement | null>()
  const styleRef = useRef<any>()
  const [cssIsInjected, setCssIsInjected] = useState(false)

  if (styleRef.current) {
    styleRef.current.onload = () => {
      setCssIsInjected(true)
    }
    styleRef.current.onerror = () => {
      // if we don't have any css file (if you use styled components)
      setCssIsInjected(true)
    }
  }

  return (
    <div id='root' ref={(newRef) => setRef(newRef)}>
      <link
        ref={styleRef}
        rel='stylesheet'
        href={
          process.env.REACT_APP_DEPLOY_PATH
            ? process.env.REACT_APP_DEPLOY_PATH + '/static/css/main.css'
            : 'static/css/main.css'
        }
      />
      {ref && cssIsInjected && (
        <div id='app'>
          <StyleSheetManager target={ref}>
            <MainComponent {...microFrontendProps} />
          </StyleSheetManager>
        </div>
      )}
    </div>
  )
}
export default App
if (window.document.title === 'TA-Interaktiv Microfrontend') {
  const DevToolAppWrapper: FC = (): ReactElement => {
    const [isDarkmode, setIsDarkmode] = useState(false)
    const [currentTenantKey, setCurrentTenantKey] =
      useState<TenantKey>('tagesanzeiger')
    return (
      <DevTools
        setTenant={setCurrentTenantKey}
        setIsDarkmode={setIsDarkmode}
        isDarkmode={isDarkmode}
        currentTenantKey={currentTenantKey}
      >
        <App
          tenant={{
            domain: 'landbote',
            feedId: 2,
            key: 'landbote',
            lang: 'de',
            name: 'Landbote',
          }}
          colorMode={isDarkmode ? 'dark' : 'light'}
        />
      </DevTools>
    )
  }
  const root = createRoot(document.getElementById('root')!)
  root.render(
    <React.StrictMode>
      <DevToolAppWrapper />
    </React.StrictMode>
  )
}
